import type { SubEvent } from '../../../types/events';
import type { UserRole } from '../../../types/session';
import isAdmin from '../../../utils/isAdmin';
import { ResultType } from '@fastnorth/timer-api';

const isDisabled = (race: SubEvent, roles?: UserRole[]): boolean => {
  // Check if roles are provided and if the user is an admin
  if (roles && isAdmin(roles)) return false;

  // Check if the race does not have results and the results type is STRUCTURED
  return !race.hasResults && race.resultsType === ResultType.STRUCTURED;
};

export default isDisabled;
